<template lang="pug" src="./custom-blog-link.pug"></template>

<script>
export default {
  props: ['content']
}
</script>



// WEBPACK FOOTER //
// custom-blog-link.vue?6575f053